<style lang="scss" scoped>
@use 'sass:color';
@use '../../../palette.scss' as *;

$input-box-width: 300px;

.organization-management-page {
    padding: 10px;
    display: flex;
    flex-flow: row wrap;

    .spinner-block {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-around;

        .spinner-container {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 60px;
            width: 60px;

            .fa,
            .fas {
                font-size: 2em;

                &.fa-check {
                    color: $theme-green;
                }

                &.fa-location-arrow {
                    color: $theme-grey;
                }
            }
        }
    }

    .prop-block {
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        align-items: baseline;
        padding: 5px 8px 15px;

        &:not(.event) {
            margin-bottom: 8px;
        }

        &.event {
            padding: 5px 10px;

            &.subhead {
                margin: 0 15px;

                &.borderline {
                    border-bottom: 1px dashed $theme-light-grey;
                }
            }
        }

        .prop {
            flex: 1;
            width: 100%;
            position: relative;

            .input-box {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-grow: 1;
                position: relative;
                margin-right: 30px;

                &.dropdown {
                    width: $input-box-width;
                    flex-grow: 0;
                    justify-content: center;
                }
            }

            .current-label {
                position: absolute;
                display: flex;
                top: 100%;
                right: 0;
                background-color: color.adjust(
                    $theme-light-grey,
                    $lightness: -5%
                );
                padding: 3px 4px 3px 2px;
                color: white;
                transform: scaleY(0);
                transition: transform 0.5s;
                font-size: 0.8em;
                transform-origin: top;
                white-space: nowrap;

                &:before {
                    content: '';
                    height: 100%;
                    position: absolute;
                    right: 100%;
                    top: 0;
                    background-image: url('../../../../assets/CurrentValueSlash.svg');
                    background-size: 100%;
                    width: 8px;
                }

                &.discrepancy {
                    transform: scaleY(1);
                }

                .revert-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 19px;
                    height: 19px;
                    margin: 0;
                    padding: 2px;
                    margin-left: 3px;
                    transition: transform 0.25s;
                    color: color.adjust(white, $lightness: -10%);
                    font-size: 0.9em;
                    padding: 1px 0 0 0;
                    background-color: transparent;
                    border: none;

                    &:focus {
                        outline: none;
                    }

                    &:active {
                        font-size: 0.8em;
                    }

                    &:hover {
                        transform: rotate(-20deg);
                    }
                }

                &:hover {
                    cursor: default;

                    .revert-icon {
                        color: white;

                        &:hover {
                            color: $theme-light-blue;
                            cursor: pointer;
                        }
                    }
                }
            }

            .twofa {
                width: 100%;
                text-align: center;
                justify-content: center;
            }
        }
    }
}

@media (min-width: 600px) {
    .organization-management-page {
        .organization-details-container {
            .childorgs {
                flex-flow: row wrap;
                justify-content: space-between;

                .childorgblock {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    margin-bottom: 17px;
                    padding: 5px;

                    .columns {
                        display: flex;
                        flex: 1;
                        justify-content: center;

                        position: relative;
                    }

                    .column {
                        flex: 1;
                        max-width: 50%;
                        text-align: center;
                        justify-content: center;
                    }

                    .fixed-width-dropdown {
                        width: 280px;
                    }

                    .narrowcolumn {
                        width: 50px;
                        text-align: center;
                        justify-content: center;
                    }

                    .delete-btn-ctn {
                        position: absolute;
                        width: 55px;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        top: 0;
                        right: 0;
                        z-index: 1;

                        button {
                            margin: 0 5px 10px 0;
                        }

                        button {
                            background-color: transparent;
                            color: $theme-red;
                            font-size: 1.7em;
                            border: none;
                            outline: none;

                            i {
                                right: 1;
                                border-radius: 50%;

                                &:hover {
                                    background-color: color.adjust(
                                        $theme-red,
                                        $alpha: -0.85
                                    );
                                    color: color.adjust(
                                        $theme-red,
                                        $lightness: -5%
                                    );
                                }

                                &:active {
                                    transform: scale(0.97);
                                }
                            }
                        }
                    }
                }

                .name {
                    font-weight: bold;
                }

                .centered-button {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 32px; /* Adjust based on button size */
                    height: 32px;
                    padding: 0;
                }

                .centered-button i {
                    vertical-align: middle;
                }

                /* .centered-button {
                    display: inline-block; 
                } */

                .current-label {
                    position: absolute;
                    display: flex;
                    top: 100%;
                    right: 0;
                    background-color: color.adjust(
                        $theme-light-grey,
                        $lightness: -5%
                    );
                    padding: 3px 4px 3px 2px;
                    color: white;
                    transform: scaleY(0);
                    transition: transform 0.5s;
                    font-size: 0.8em;
                    transform-origin: top;
                    white-space: nowrap;

                    &:before {
                        content: '';
                        height: 100%;
                        position: absolute;
                        right: 100%;
                        top: 0;
                        background-image: url('../../../../assets/CurrentValueSlash.svg');
                        background-size: 100%;
                        width: 8px;
                    }

                    &.discrepancy {
                        transform: scaleY(1);
                    }

                    .revert-icon {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 19px;
                        height: 19px;
                        margin: 0;
                        padding: 2px;
                        margin-left: 3px;
                        transition: transform 0.25s;
                        color: color.adjust(white, $lightness: -10%);
                        font-size: 0.9em;
                        padding: 1px 0 0 0;
                        background-color: transparent;
                        border: none;

                        &:focus {
                            outline: none;
                        }

                        &:active {
                            font-size: 0.8em;
                        }

                        &:hover {
                            transform: rotate(-20deg);
                        }
                    }

                    &:hover {
                        cursor: default;

                        .revert-icon {
                            color: white;

                            &:hover {
                                color: $theme-light-blue;
                                cursor: pointer;
                            }
                        }
                    }
                }

                // .delete-btn-ctn{
                //     opacity: 0;
                // }
            }

            .dotted-line {
                border-bottom: 1px dashed $theme-light-grey;
                //border-top: 1px dotted #9c9c9c;
                width: 100%;
                margin-top: 5px;
            }

            .prop-block {
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;

                .prop {
                    &:not(.name) {
                        text-align: left;
                    }

                    &.toggle {
                        padding-right: 15px;
                    }

                    .delete-btn-ctn,
                    .test-btn-ctn {
                        opacity: 0;
                    }

                    &.name {
                        font-weight: bold;
                    }

                    &.discrepancy {
                        transform: scaleY(1);
                    }
                }
            }
        }
    }
}

.pad-right {
    width: auto;
    margin-right: 8px;
}

.prop {
    &.input {
        flex-grow: 1;
        padding: 0 15px;
    }
}
</style>

<template>
    <div class="organization-management-page">
        <SaveWidget
            :state="saveState"
            :customFailText="saveFailText"
            @save="saveOrganizationSettings"
            @retry="saveOrganizationSettings"
            @cancel="cancelOrganizationSettings"
            @hide="saveSucceeded = false"
        />

        <!-- Organization Management card -->
        <Card :maxWidth="'700px'" fullWidth color="blue">
            <template #header>{{ $t('organizationManagement') }}</template>
            <template #body>
                <div class="organization-details-container">
                    <!-- My Organization -->
                    <div class="prop-block">
                        <div class="prop name">{{ $t('myOrganization') }}</div>
                        <div class="prop">
                            <div class="input-box">
                                <InputBox
                                    type="text"
                                    center
                                    :readonly="isUserAdmin"
                                    v-model="myOrganization.organizationName"
                                >
                                    <div
                                        class="current-label"
                                        :class="{
                                            discrepancy:
                                                initialOrganization.organizationName !==
                                                myOrganization.organizationName,
                                        }"
                                    >
                                        {{ $t('currently') }}:
                                        {{
                                            this.initialOrganization
                                                .organizationName
                                        }}
                                        <button
                                            class="revert-icon"
                                            @click="
                                                myOrganization.organizationName =
                                                    initialOrganization.organizationName
                                            "
                                            v-tooltip.right="$t('revertValue')"
                                            tabindex="-1"
                                        >
                                            <i class="fa fa-undo-alt"></i>
                                        </button>
                                    </div>
                                </InputBox>
                                <div class="button-box"></div>
                            </div>
                        </div>
                    </div>

                    <!-- Parent Organization -->
                    <div class="prop-block">
                        <div class="prop name">
                            {{ $t('parentOrganization') }}
                        </div>
                        <div class="prop">
                            <div class="input-box">
                                <InputBox
                                    type="text"
                                    center
                                    readonly="true"
                                    :value="
                                        getParentName(myOrganization.parentId)
                                    "
                                />
                                <div class="button-box"></div>
                            </div>
                        </div>
                    </div>

                    <!-- 2FA for the user's own org; server admins have none and set 2FA per org in the list below -->
                    <div v-if="!isUserAdmin" class="prop-block">
                        <div class="prop name">{{ $t('2fa') }}</div>
                        <div class="prop toggle">
                            <Checkbox
                                class="twofa"
                                @change="setTwoFA($event, myOrganization)"
                                :checked="myOrganization.twoFa"
                            ></Checkbox>
                        </div>
                    </div>

                    <!-- Child Organizations -->
                    <div class="prop-block">
                        <div class="prop name">
                            {{ $t('childOrganizations') }}
                        </div>
                    </div>
                    <div class="childorgs">
                        <div class="childorgblock">
                            <div class="columns">
                                <!-- Name Title-->
                                <div class="name column">{{ $t('name') }}</div>
                                <!-- Direct Parent Title -->
                                <div class="name column">
                                    {{ $t('directParent') }}
                                </div>

                                <!-- 2FA Title -->
                                <div class="name narrowcolumn">
                                    {{ $t('2fa') }}
                                </div>
                                <!-- Add new Child Plus button -->
                                <div class="narrowcolumn">
                                    <Button
                                        circle
                                        small
                                        class="centered-button"
                                        @click="addChildOrganization"
                                        outline
                                        ><i class="fa fa-plus"></i
                                    ></Button>
                                </div>
                            </div>
                        </div>
                        <div class="dotted-line"></div>

                        <div
                            v-for="(
                                childOrganization, index
                            ) in myChildOrganizations"
                            :key="childOrganization.id"
                        >
                            <div class="childorgblock">
                                <div class="columns">
                                    <!-- Enter Child Name -->
                                    <div class="input-box">
                                        <InputBox
                                            type="text"
                                            center
                                            v-model="
                                                childOrganization.organizationName
                                            "
                                            @blur="
                                                setOrganizationName(
                                                    childOrganization,
                                                )
                                            "
                                        >
                                            <div
                                                class="current-label"
                                                :class="{
                                                    discrepancy:
                                                        childOrganization.initialOrganizationName !==
                                                        childOrganization.organizationName,
                                                }"
                                            >
                                                {{ $t('currently') }}:
                                                {{
                                                    childOrganization.initialOrganizationName
                                                }}
                                                <button
                                                    class="revert-icon"
                                                    @click="
                                                        childOrganization.organizationName =
                                                            childOrganization.initialOrganizationName
                                                    "
                                                    v-tooltip.right="
                                                        $t('revertValue')
                                                    "
                                                    tabindex="-1"
                                                >
                                                    <i
                                                        class="fa fa-undo-alt"
                                                    ></i>
                                                </button>
                                            </div>
                                        </InputBox>
                                        <div class="button-box"></div>
                                    </div>

                                    <!-- Select Direct Parent -->
                                    <div class="column">
                                        <DropdownMenu
                                            class="fixed-width-dropdown"
                                            :options="
                                                parentOrganizationOptions(
                                                    childOrganization,
                                                )
                                            "
                                            :maxHeight="'200px'"
                                            outline
                                            @change="
                                                setParentOrganizationChange(
                                                    $event,
                                                    childOrganization,
                                                )
                                            "
                                            :value="
                                                childOrganization.organizationParentId ==
                                                null
                                                    ? 0
                                                    : parseInt(
                                                          childOrganization.organizationParentId,
                                                      )
                                            "
                                        >
                                            <div
                                                class="current-label"
                                                :class="{
                                                    discrepancy:
                                                        childOrganization.initialParentId !==
                                                        childOrganization.organizationParentId,
                                                }"
                                            >
                                                {{ $t('currently') }}:
                                                {{
                                                    getParentName(
                                                        childOrganization.initialParentId,
                                                    )
                                                }}
                                                <button
                                                    class="revert-icon"
                                                    @click="
                                                        childOrganization.organizationParentId =
                                                            childOrganization.initialParentId
                                                    "
                                                    v-tooltip.right="
                                                        $t('revertValue')
                                                    "
                                                    tabindex="-1"
                                                >
                                                    <i
                                                        class="fa fa-undo-alt"
                                                    ></i>
                                                </button>
                                            </div>
                                        </DropdownMenu>
                                    </div>

                                    <!-- 2FA Checkbox -->
                                    <div class="narrowcolumn">
                                        <Checkbox
                                            @change="
                                                setTwoFA(
                                                    $event,
                                                    childOrganization,
                                                )
                                            "
                                            :checked="childOrganization.twoFa"
                                        ></Checkbox>
                                    </div>

                                    <!-- Delete Child button -->
                                    <div
                                        class="narrowcolumn delete-btn-ctn"
                                        v-if="
                                            showDeleteOrganization(
                                                childOrganization,
                                            )
                                        "
                                    >
                                        <button
                                            @click="
                                                deleteChildOrganization(index)
                                            "
                                        >
                                            <i class="far fa-times-circle" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import toastr from 'toastr';
import { mapGetters } from 'vuex';

import * as client from '../../../api/client';
import {
    getOrganizations,
    getOrganizationUser,
    saveMyOrganization,
    deleteMyChildOrganizations,
    getOrganizationUsers,
} from '../../../api/organizations';
import { getCurrentUser } from '../../../api/user';
import { getUnitOrganizations } from '../../../api/units';

export default {
    name: 'organizationManagement',

    data() {
        return {
            myOrganization: undefined,
            parentOrganization: {},
            organizations: [],
            organizationUsers: [],
            myChildOrganizations: [],
            parentOrganizations: [
                {
                    label: 'None',
                    value: 0,
                },
            ],
            initialOrganization: undefined,
            deletedMyChildOrganizations: [],
            unitOrganizations: [],
            isReadOnly: false,
            saveInProgress: false, // An api call to save the campaign is being made right now
            saveFailed: false, // The last call to save failed
            saveSucceeded: false, // The last call to save succeeded
            saveFailText: '', // Text to pass to the save widget in the event that a save fails,
        };
    },

    watch: {
        myOrganization: {
            deep: true,
            handler(val, oldVal) {
                // If we changed users, we haven't actually edited any values
                if (val && oldVal && val === oldVal) {
                    this.edits = true;
                }
            },
        },

        myChildOrganizations: {
            deep: true,
            handler(val, oldVal) {
                if (val && oldVal && val === oldVal) {
                    this.edits = true;
                }
            },
        },
    },

    computed: {
        ...mapGetters(['isUserAdmin']),

        // Used by the save widget and for knowing whether or not the user has unsaved changes when navigating
        edits: {
            get() {
                return this.$store.state.editsOnPage;
            },

            set(value) {
                this.$store.commit('setEditsOnPage', value);
            },
        },

        saveState() {
            if (this.saveInProgress) {
                return 'sending';
            } else if (this.saveFailed) {
                return 'retry';
            } else if (this.saveSucceeded && !this.edits) {
                return 'success';
            } else if (this.edits) {
                return 'changes';
            }

            return 'hidden';
        },
    },

    created: function () {
        this.setupPage();
    },

    methods: {
        async setupPage() {
            this.initialOrganization = {
                organizationId: null,
                organizationName: 'None',
                parentId: null,
                twoFa: false,
                initialOrganizationName: 'None',
                initialParentId: null,
            };
            this.myOrganization = {
                organizationId: null,
                organizationName: 'None',
                parentId: null,
                twoFa: false,
                initialOrganizationName: 'None',
                initialParentId: null,
            };
            this.organizations = [];
            this.unitOrganizations = undefined;
            this.parentOrganizations = [{ label: 'None', value: 0 }];

            const user = await getCurrentUser();

            const result = await getOrganizationUsers();
            if (result) {
                this.organizationUsers = result.payload.rows;
            }

            const response = await getOrganizationUser(
                this.$store.state.currentUser.id,
            );
            var myOrgId = undefined;
            if (response.payload != null) {
                myOrgId = response.payload.organization_id;
            }

            // Get all Organizations
            await this.getAllOrganizations();
            // Get all parent dropdown organizations based on all returned organizations
            for (const organization of this.organizations) {
                this.parentOrganizations.push({
                    label: organization.organizationName,
                    value: parseInt(organization.organizationId),
                });
                if (
                    !this.isUserAdmin &&
                    organization.organizationId === myOrgId
                ) {
                    this.myOrganization = organization;
                }
            }
            this.initialOrganization = { ...this.myOrganization };

            await this.getMyChildOrganizations();

            const unitOrgResponse = await getUnitOrganizations();
            if (
                unitOrgResponse?.status === 'OK' &&
                Array.isArray(unitOrgResponse.payload)
            ) {
                this.unitOrganizations = unitOrgResponse.payload;
            } else {
                this.unitOrganizations = [];
            }

            // page is refreshed so override any edit flags to show no edits need saving
            this.edits = false;
        },

        async getMyChildOrganizations() {
            // clear the myChildOrganizations array
            this.myChildOrganizations = [];
            if (this.isUserAdmin) {
                this.isReadOnly = true;
                for (const organization of this.organizations) {
                    this.myChildOrganizations.push({
                        organizationId: organization.organizationId,
                        organizationName: organization.organizationName,
                        organizationParentId: organization.parentId,
                        twoFa: !!organization.twoFa,
                        initialOrganizationName: organization.organizationName,
                        initialParentId: organization.parentId,
                    });
                }
            } else {
                await this.addMyChildOrganizations(
                    this.myOrganization.organizationId,
                );
            }

            // sort child organizations by name
            this.myChildOrganizations = this.myChildOrganizations
                .slice()
                .sort((a, b) => {
                    return a.organizationName
                        .toLowerCase()
                        .localeCompare(b.organizationName.toLowerCase());
                });
        },

        async addMyChildOrganizations(parentsId) {
            for (const organization of this.organizations) {
                if (organization.parentId === parentsId) {
                    this.myChildOrganizations.push({
                        organizationId: organization.organizationId,
                        organizationName: organization.organizationName,
                        organizationParentId: organization.parentId,
                        twoFa: !!organization.twoFa,
                        initialOrganizationName: organization.organizationName,
                        initialParentId: organization.parentId,
                    });
                    await this.addMyChildOrganizations(
                        organization.organizationId,
                    );
                }
            }
        },

        async getAllOrganizations() {
            // get organizations list from database
            const data = await getOrganizations();
            for (const organization of data.payload) {
                this.organizations.push({
                    organizationName: organization.organization_name,
                    organizationId: organization.id,
                    parentId: organization.parent_organization_id,
                    twoFa: !!organization.two_factor,
                });
            }
        },

        parentOrganizationOptions(currentOrganization) {
            var newParentOrganizationOptions = [...this.parentOrganizations];
            var cnt = 0;
            if (this.isUserAdmin) {
                for (const organization of newParentOrganizationOptions) {
                    if (
                        organization.label ===
                        currentOrganization.organizationName
                    ) {
                        newParentOrganizationOptions.splice(cnt, 1);
                    }
                    cnt++;
                }
            } else {
                newParentOrganizationOptions =
                    this.addChildrenParentOrganizationOptions(
                        [],
                        this.myOrganization.organizationId,
                    );
                for (const childOrg of this.myChildOrganizations) {
                    // do not add itself to its own parentOrganization options
                    if (
                        childOrg.organizationId !==
                        currentOrganization.organizationId
                    ) {
                        newParentOrganizationOptions =
                            this.addChildrenParentOrganizationOptions(
                                newParentOrganizationOptions,
                                childOrg.organizationId,
                            );
                    }
                }
            }

            return newParentOrganizationOptions;
        },

        addChildrenParentOrganizationOptions(
            newParentOrganizations,
            directParentId,
        ) {
            // attempt to find a matching organization from list of parent organizations
            const newParentOrganization = this.parentOrganizations.find(
                (o) => Number(o.value) === Number(directParentId),
            );

            // if no organiztions exists just exit there is no organization to add to options in parent organizations
            if (!newParentOrganization) {
                return newParentOrganizations;
            }

            // do not add option if it already exists in the options
            if (
                newParentOrganizations.some(
                    (org) => org.value === newParentOrganization.value,
                )
            ) {
                return newParentOrganizations;
            }

            // add parent organizations
            newParentOrganizations.push(newParentOrganization);

            // return the result if the child is a parent also, recursive calls here will check children of children as parents etc.
            return this.addChildrenParentOrganizationOptions(
                newParentOrganizations,
                newParentOrganization.value,
            );
        },

        addChildOrganization() {
            // adds a row to the child organization list ready for data to be added
            this.myChildOrganizations.push({
                organizationId: this.parentOrganizations.length * 100, //-1,
                organizationName: '',
                organizationParentId: this.isUserAdmin
                    ? null
                    : this.myOrganization.organizationId,
                twoFa: false,
                initialOrganizationName: '',
                initialParentId: null,
            });
        },

        deleteChildOrganization(index) {
            this.deletedMyChildOrganizations.push(
                this.myChildOrganizations[index],
            );
            this.myChildOrganizations.splice(index, 1);
        },

        getParentName(parentId) {
            // if no parent id return none as the option
            if (parentId === null) {
                return 'None';
            }

            // all other parent id's return the name of the organization associated with that id
            for (const organization of this.organizations) {
                if (organization.organizationId === parentId) {
                    return organization.organizationName;
                }
            }
        },

        showDeleteOrganization(childOrganization) {
            return !this.isParentOrganization(childOrganization.organizationId);
        },

        isParentOrganization(id) {
            // Returns true when this org has NO children (safe to delete),
            // false when it does have children (used as a parent).
            return this.myChildOrganizations.some(
                (o) => Number(o.organizationParentId) === Number(id),
            );
        },

        setOrganizationName(childOrganization) {
            // if id is matched it is a change to field
            const parentOrganization = this.parentOrganizations.find(
                (o) =>
                    Number(o.value) ===
                    Number(childOrganization.organizationId),
            );

            if (parentOrganization) {
                parentOrganization.label = childOrganization.organizationName;
            } else {
                const parentOrganization = this.parentOrganizations.find(
                    (o) => o.label === childOrganization.organizationName,
                );

                if (
                    childOrganization.organizationName ==
                        this.myOrganization.organizationName ||
                    parentOrganization
                ) {
                    toastr.error(this.$t('nameExists'));
                    var goodName = false;
                    var nameExt = '';
                    while (!goodName) {
                        nameExt += '*';
                        const testName = this.parentOrganizations.find(
                            (o) =>
                                o.label ===
                                childOrganization.organizationName + nameExt,
                        );
                        if (typeof testName === 'undefined') {
                            goodName = true;
                        }
                    }
                    childOrganization.organizationName =
                        childOrganization.organizationName + nameExt;
                }

                this.parentOrganizations.push({
                    label: childOrganization.organizationName,
                    value: this.parentOrganizations.length * 100,
                });
            }
        },

        setTwoFA(event, organization) {
            const selectedValue = event.target?.checked ?? !!event;
            // set organization twoFA as a change for the child organization
            if (selectedValue) {
                organization.twoFa = selectedValue;
                this.recursivelySetTwoFA(organization.organizationId);
            } else {
                organization.twoFa = selectedValue;
            }
        },

        recursivelySetTwoFA(currentOrganizationId) {
            // if the child organization is a parent organization, set all children to the same twoFA value
            if (this.isParentOrganization(currentOrganizationId)) {
                for (const organization of this.myChildOrganizations) {
                    if (
                        Number(organization.organizationParentId) ===
                        Number(currentOrganizationId)
                    ) {
                        organization.twoFa = true;
                        this.recursivelySetTwoFA(organization.organizationId);
                    }
                }
            }
        },

        setParentOrganizationChange(event, childOrganization) {
            const selectedValue = event;

            // do not allow cross referencing of direct parents
            if (
                !this.myChildOrganizations.find(
                    (o) =>
                        Number(o.organizationId) === Number(selectedValue) &&
                        Number(childOrganization.organizationId) ===
                            Number(o.organizationParentId),
                )
            ) {
                childOrganization.organizationParentId = selectedValue;
            } else {
                toastr.error('Direct Parent Cross Reference Detected'); //this.$t('commandSendFailure'));
            }
        },

        // save organization data
        async saveOrganizationSettings() {
            this.edits = false;
            this.saveInProgress = true;
            let errorResponse = null;
            let response = null;

            var cleanedMyChildOrganizations = [];
            for (const organization of this.myChildOrganizations) {
                if (organization.organizationName.trim() === '') {
                    response = {
                        status: client.STATUS_ERROR,
                        msg: 'Organization Name Blank!',
                    };
                    errorResponse = response;
                    break;
                }

                cleanedMyChildOrganizations.push({
                    id: organization.organizationId,
                    organization_name: organization.organizationName.trim(),
                    parent_organization_id:
                        organization.organizationParentId === 0
                            ? null
                            : organization.organizationParentId,
                    two_factor: !!organization.twoFa,
                });
            }

            if (!errorResponse) {
                let updateOrganization = {
                    id: this.myOrganization.organizationId,
                    organization_name: this.myOrganization.organizationName,
                    parent_organization_id: this.myOrganization.parentId,
                    two_factor: !!this.myOrganization.twoFa,
                    myChildOrganizations: cleanedMyChildOrganizations,
                };

                // should only need to save the updateOrganization information
                response = await saveMyOrganization(updateOrganization);

                if (response.status === client.STATUS_ERROR) {
                    errorResponse = response;
                }

                if (
                    this.deletedMyChildOrganizations &&
                    this.deletedMyChildOrganizations.length > 0
                ) {
                    response = await deleteMyChildOrganizations(
                        this.deletedMyChildOrganizations,
                    );
                    if (response.status === client.STATUS_ERROR) {
                        errorResponse = response;
                    }
                }

                const newOrganizationsList = response?.payload?.rows;
                if (Array.isArray(newOrganizationsList)) {
                    this.$store.commit(
                        'setOrganizations',
                        newOrganizationsList,
                    );
                }
            }

            if (errorResponse) {
                if (response.msg) {
                    this.saveFailText = this.$t(
                        response.msg,
                        response.msg_data,
                    );
                }
                this.saveFailed = true;
                this.saveSucceeded = false;
            } else {
                this.saveFailed = false;
                this.saveSucceeded = true;
                this.saveFailText = '';

                await this.setupPage();
            }
            this.saveInProgress = false;

            this.$root.$emit('pageSaveComplete');
        },

        // cancel organization edit
        async cancelOrganizationSettings() {
            this.myOrganization = {
                ...this.initialOrganization,
            };
            this.deletedChildOrganization = [];
            await this.getMyChildOrganizations();
            setTimeout(() => {
                this.edits = false;
            });

            this.saveFailed = false;
            this.saveSucceeded = true;
        },
    },
};
</script>
